module.exports = __webpack_public_path__ + "img/box_bonus.e2969142.png";